import React from 'react';
export function Footer() {
  return <footer className="bg-dark-card border-t border-dark-border pt-16 pb-8 px-4 text-center" data-id="element-120">
      <div className="max-w-4xl mx-auto" data-id="element-121">
        <div className="mb-8" data-id="element-122">
          <div className="inline-flex items-center space-x-2 text-2xl font-black mb-4" data-id="element-123">
            <span data-id="element-124">💅</span>
            <span data-id="element-125">ULTRAPACK DIGITAL™</span>
          </div>
          <p className="text-gray-400 max-w-md mx-auto" data-id="element-126">
            El sistema N°1 para manicuristas independientes que quieren vivir de
            lo que aman en Argentina.
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-127">
            Porque tener talento no alcanza. Necesitás un sistema. Y hoy lo
            tenés.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 mb-12" data-id="element-128">
          <a href="mailto:ultrapack.d@gmail.com" className="hover:text-brand transition-colors" data-id="element-129">
            📧 ultrapack.d@gmail.com
          </a>
          <a href="#" className="hover:text-brand transition-colors" data-id="element-130">
            📲 @ultrapack.digital
          </a>
          <a href="https://ultrapack-digital.com" className="hover:text-brand transition-colors" data-id="element-131">
            🌐 ultrapack-digital.com
          </a>
        </div>

        <div className="border-t border-dark-border/50 pt-8 text-xs text-gray-600" data-id="element-132">
          <p className="mb-4" data-id="element-133">
            © ULTRAPACK DIGITAL™ 2024 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="italic text-gray-500 text-sm" data-id="element-134">
            💅 "El negocio que merecés no empieza cuando tenés más clientas.
            Empieza cuando decidís construirlo con sistema."
          </p>
        </div>
      </div>
    </footer>;
}